import axios from "../../axiosMiddleware/index";
import { api } from "../../apiendpoints/index";

export const GetSSTeam = async () => {
  return axios.get(`${api.DASHBOARD.TEAM}`);
};

// export const GetNotification = async () => {
//   return axios.get(`${api.DASHBOARD.NOTIFICATIONS}`);
// };


export const GetNotification = async () => {
  return axios.get(`${api.DASHBOARD.GET_NOTIFICATIONS}`);
};
